export default __webpack_public_path__ + "static/media/Hyper1.ac56eebf.jpg";